module.exports = __webpack_public_path__ + "static/media/TransferenciaModeloPadrao.97e7eae4.xlsx";